import { type FC } from 'react';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import starsPng from '/img/patterns/stars-square-card.png';
import starsWebp from '/img/patterns/stars-square-card.webp';

interface ContractBackgroundProps {
  type: 'green' | 'purple';
  disabled?: boolean;
  className?: string;
}

const ContractBackground: FC<ContractBackgroundProps> = ({
  type,
  disabled = false,
  className,
}) => {
  const content = (
    <>
      <Picture
        alt="stars"
        img={starsPng}
        webp={starsWebp}
        className={
          'w-full h-full absolute top-0 left-0 z-[-1] [&>img]:object-cover aspect-square min-w-20'
        }
      />

      <div
        className={cn('absolute inset-0 opacity-30 blur-xl z-[-1]', {
          'bg-[#3F700E]': type === 'green' && !disabled,
          'bg-[#9955FF]': type === 'purple' && !disabled,
          'bg-white/40': disabled,
        })}
      />

      <div
        className={cn(
          'blur-[16px] absolute w-[68.75%] h-[43.75%] rounded-full z-[-1]',
          'top-[-23.25%] left-1/2 transform -translate-x-1/2',
          {
            'bg-[#3F700E]': type === 'green' && !disabled,
            'bg-[#9955FF]': type === 'purple' && !disabled,
            'bg-white/40': disabled,
          },
        )}
      />

      {!disabled && (
        <div
          className={cn(
            'blur-[20px] absolute w-full h-[68.75%] rounded-full z-[-1]',
            'bottom-0 left-0',
            {
              'bg-[#3F700E]': type === 'green',
              'bg-[#5C3695]': type === 'purple',
            },
          )}
        />
      )}
    </>
  );

  return className ? (
    <div className={className}>{content}</div>
  ) : (
    <>{content}</>
  );
};

export default ContractBackground;
